"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTimeConstantsDocumentation = exports.dateTime = void 0;
const constants_1 = require("./constants");
exports.dateTime = {
    RFC3339: "yyyy-MM-dd'T'HH:mm:ssXXX",
    RFC3339Millis: "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
    EDIDate: "yyMMdd",
    EDIDateLong: "yyyyMMdd",
    EDITime: "HHmm",
};
exports.dateTimeConstantsDocumentation = [
    {
        label: "$dateTime.RFC3339",
        detail: "$dateTime.RFC3339",
        documentation: `A shorthand for "${exports.dateTime.RFC3339}" date format which is useful for parsing ISO-8859 dates. Example: 2021-07-31T12:00:00Z.
${constants_1.STEDI_BINDING_DISCLAIMER}`,
        insertText: "$dateTime.RFC3339",
    },
    {
        label: "$dateTime.RFC3339Millis",
        detail: "$dateTime.RFC3339Millis",
        documentation: `A shorthand for "${exports.dateTime.RFC3339Millis}" date format, same as $dateTime.RFC3339 but includes milliseconds, useful for parsing dates returned by $now() function. Example: 2021-07-31T12:00:00.123Z.
${constants_1.STEDI_BINDING_DISCLAIMER}`,
        insertText: "$dateTime.RFC3339Millis",
    },
    {
        label: "$dateTime.EDIDate",
        detail: "$dateTime.EDIDate",
        documentation: `A shorthand for "${exports.dateTime.EDIDate}" date format. Example: 210731.
${constants_1.STEDI_BINDING_DISCLAIMER}`,
        insertText: "$dateTime.EDIDate",
    },
    {
        label: "$dateTime.EDITime",
        detail: "$dateTime.EDITime",
        documentation: `A shorthand for "${exports.dateTime.EDITime}" time format. Example: 1215.
${constants_1.STEDI_BINDING_DISCLAIMER}`,
        insertText: "$dateTime.EDITime",
    },
    {
        label: "$dateTime.EDIDateLong",
        detail: "$dateTime.EDIDateLong",
        documentation: `A shorthand for "${exports.dateTime.EDIDateLong}" date format. Example: 20210731.
${constants_1.STEDI_BINDING_DISCLAIMER}`,
        insertText: "$dateTime.EDIDateLong",
    },
];
